import { apiUrl } from '../config';
import { fetch, handleApiError, upload } from '../utils/http';

function fetchCommuniquesStart() {
    return {
        type : 'FETCH_COMMUNIQUES_START'
    }
}

function fetchCommuniquesSuccess(data) {
    return {
        type : 'FETCH_COMMUNIQUES_SUCCESS',
        data
    }
}

function fetchCommuniquesFailure(error) {
    return {
        type : 'FETCH_COMMUNIQUES_FAILURE',
        error
    }
}


export function fetchCommuniques() {
    return function(dispatch) {
        dispatch(fetchCommuniquesStart());
        const url = `${apiUrl()}/communiques`;
        fetch(url)
            .then(response => response.json())
            .then(data => dispatch(fetchCommuniquesSuccess(data)))
            .catch(err => handleApiError(err, dispatch, fetchCommuniquesFailure));
    }
}

function deleteCommuniqueStart() {
    return {
        type : 'DELETE_COMMUNIQUE_START'
    }
}

function deleteCommuniqueSuccess(item) {
    return {
        type : 'DELETE_COMMUNIQUE_SUCCESS',
        item
    }
}

function deleteCommuniqueFailure(error) {
    return {
        type : 'DELETE_COMMUNIQUE_FAILURE',
        error
    }
}


export function deleteCommunique(item) {
    return function(dispatch) {
        dispatch(deleteCommuniqueStart());
        const url = `${apiUrl()}/communiques/${item.id}`;
        fetch(url, {
            method : 'DELETE'
        })
            .then(response => response.json())
            .then(data => dispatch(deleteCommuniqueSuccess(data)))
            .catch(err => handleApiError(err, dispatch, deleteCommuniqueFailure));
    }
}

function storeCommuniqueStart(xhr, editedItem) {
    return {
        type : 'STORE_COMMUNIQUE_START',
        xhr,
        editedItem,
    };
}

function storeCommuniqueProgress(progress) {
    return {
        type : 'STORE_COMMUNIQUE_PROGRESS',
        progress,
    };
}

function storeCommuniqueCancel() {
    return {
        type : 'STORE_COMMUNIQUE_CANCEL'
    };
}

function storeCommuniqueSuccess(item) {
    return {
        type : 'STORE_COMMUNIQUE_SUCCESS',
        item
    };
}

function storeCommuniqueFailure(error) {
    return {
        type : 'STORE_COMMUNIQUE_FAILURE',
        error
    };
}


export function storeCommunique(data) {
    const url = `${apiUrl()}/communiques/${data.item ? data.item.id : ''}`;
    const formData = {...data};
    delete formData.file;
    delete formData.cover;
    delete formData.item;
    return function(dispatch) {
        const xhr = upload(
            url,
            {
                'file' : data.file,
                'cover' : data.cover,
            },
            (evt) => {
                const newItem = JSON.parse(xhr.responseText);
                dispatch(storeCommuniqueSuccess(newItem));
            },
            (error) => {
                dispatch(storeCommuniqueFailure(error));
            },
            (evt) => {
                dispatch(storeCommuniqueProgress(100 * evt.loaded /evt.total));
            },
            (evt) => {
                dispatch(storeCommuniqueCancel());
            },
            formData,
            {
                method : data.item ? 'PUT' : 'POST'
            }
        );
        dispatch(storeCommuniqueStart(xhr, data.item));
        
    }
}


/** WEBPACK FOOTER **
 ** ./src/actions/communiques.js
 **/